import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

export function Privacy() {
  const { t, i18n } = useTranslation('legal')

  const purposeItems = t('privacy.purposes.items', { returnObjects: true }) as string[]
  const rightsItems = t('privacy.rights.items', { returnObjects: true }) as string[]

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('privacy.meta.title')}</title>
        <meta name="description" content={t('privacy.meta.description')} />
      </Helmet>

      <section className="pt-24 sm:pt-32 pb-12 sm:pb-20 bg-gray-900">
        <div className="container-custom">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white"
          >
            {t('privacy.title')}
          </motion.h1>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-sm sm:prose-lg">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                {t('privacy.controller.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('privacy.controller.name')}<br />
                {t('privacy.controller.address')}<br />
                {t('privacy.controller.vat')}<br />
                {t('privacy.controller.email')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('privacy.dataTypes.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4">
                {t('privacy.dataTypes.p1')}
              </p>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('privacy.dataTypes.p2')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('privacy.purposes.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4">
                {t('privacy.purposes.intro')}
              </p>
              <ul className="list-disc list-inside text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 space-y-1.5 sm:space-y-2">
                {purposeItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('privacy.legalBasis.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('privacy.legalBasis.text')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('privacy.rights.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4">
                {t('privacy.rights.intro')}
              </p>
              <ul className="list-disc list-inside text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 space-y-1.5 sm:space-y-2">
                {rightsItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('privacy.retention.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('privacy.retention.text')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('privacy.changes.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700">
                {t('privacy.changes.text')}
              </p>

              <p className="text-gray-500 mt-6 sm:mt-8 text-xs sm:text-sm">
                {t('privacy.lastUpdate')}
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  )
}
